import { render, staticRenderFns } from "./SecurityPolicy.vue?vue&type=template&id=74416353&scoped=true"
import script from "./SecurityPolicy.vue?vue&type=script&lang=ts"
export * from "./SecurityPolicy.vue?vue&type=script&lang=ts"
import style0 from "./SecurityPolicy.vue?vue&type=style&index=0&id=74416353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74416353",
  null
  
)

export default component.exports